module.exports = __webpack_public_path__ + "static/media/diana-rodriguez.d0b7b8c3.md";